export default __webpack_public_path__ + "static/media/trophy.5b1e669b.svg";